// Its own module so a check of the masthead alone (typeDress.test.ts) does not
// load the World rail's whole graph: stores, liveness, search and updates.

/**
 * The product masthead (FD3, ruling D-FD2 at the principal's word 2026-09-01:
 * "rather than the neucleos logo in the cleo-code footer, its top right
 * now"): the estate wordmark seated first in the window's topmost row. It is
 * product identity, never World identity — the entered World's face lives on
 * its own door (the WorldMark seat retired into the active tab). The word
 * naming the web door never appears here: that name belongs to the web
 * surface; this is the Desk.
 */
export function DeskMasthead() {
  return (
    <span
      className="flex shrink-0 items-center pr-1"
      data-cleo="desk-masthead"
      // FD7: the brand voice — any text this seat ever carries speaks
      // Comfortaa through the one font vocabulary.
      style={{ fontFamily: "var(--font-brand)" }}
      title="Neucleos"
    >
      <img
        alt="Neucleos"
        className="hidden h-[22px] w-auto dark:block"
        draggable={false}
        src="/brand/neucleos-logo-dark.png"
      />
      <img
        alt="Neucleos"
        className="block h-[22px] w-auto dark:hidden"
        draggable={false}
        src="/brand/neucleos-logo-light.png"
      />
    </span>
  );
}
